export const formatPlanPrice = (planPrice: string, isIndividual: boolean) => {
	if (isIndividual) return 'Индивидуальный'
	if (planPrice.split('.')[0] === '0') return 'Демо-доступ'
	return ` ${planPrice.split('.')[0]} ₽`
}
